document.addEventListener("DOMContentLoaded", function() {
    // Отримуємо всі радіо-кнопки для вибору кольорів
    var colorOptions = document.querySelectorAll('input[name^="template--"][name*="farbe-option"]');
    
    // Отримуємо всі посилання на зображення в основній секції і секції thumbnails
    var imageLinks = document.querySelectorAll('.product-detail__image a');
    var thumbnailLinks = document.querySelectorAll('.product-detail__thumbnails a');

    // Функція для приховування зображень на основі вибраного кольору
    function updateImagesBasedOnSelection() {
        // Знаходимо вибраний колір
        var selectedColor = document.querySelector('input[name^="template--"][name*="farbe-option"]:checked').value;

        // Проходимо по всіх основних зображеннях
        imageLinks.forEach(function(link) {
            var img = link.querySelector('img');
            var altText = img.getAttribute('alt');
            
            // Якщо alt починається з #, то перевіряємо його на відповідність вибраному кольору
            if (altText && altText.startsWith('#')) {
                if (altText.slice(1).toLowerCase() !== selectedColor.toLowerCase()) {
                    // Приховуємо зображення, якщо alt не відповідає вибраному кольору
                    link.style.display = 'none';
                } else {
                    // Показуємо зображення, якщо alt відповідає вибраному кольору
                    link.style.display = 'block';
                }
            }
        });

        // Проходимо по всіх thumbnails
        thumbnailLinks.forEach(function(link) {
            var img = link.querySelector('img');
            var altText = img.getAttribute('alt');
            
            // Якщо alt починається з #, то перевіряємо його на відповідність вибраному кольору
            if (altText && altText.startsWith('#')) {
                if (altText.slice(1).toLowerCase() !== selectedColor.toLowerCase()) {
                    // Приховуємо зображення, якщо alt не відповідає вибраному кольору
                    link.style.display = 'none';
                } else {
                    // Показуємо зображення, якщо alt відповідає вибраному кольору
                    link.style.display = 'block';
                }
            }
        });
    }

    // Додаємо слухачі на зміну кольору
    colorOptions.forEach(function(option) {
        option.addEventListener('change', updateImagesBasedOnSelection);
    });

    // Оновлюємо зображення при завантаженні сторінки
    updateImagesBasedOnSelection();
});
